import { render, staticRenderFns } from "./GestionAuditoria.vue?vue&type=template&id=6cbe392a&"
import script from "./GestionAuditoria.vue?vue&type=script&lang=js&"
export * from "./GestionAuditoria.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports